import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useTheme } from '../App';

const CurrentAffairsTestPage = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleNotifyMe = async () => {
    if (!email || !email.includes('@')) {
      setMessage('Please enter a valid email address');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const response = await axios.post(`${API}/notifications`, {
        email: email,
        page: 'current-affairs-test',
        source: 'notify-me-button'
      });

      setMessage(response.data.message || 'Thank you! We will notify you when we launch.');
      setEmail(''); // Clear the input
    } catch (error) {
      console.error('Error saving notification:', error);
      setMessage('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      
      {/* Coming Soon Hero Section */}
      <section style={{ 
        padding: '6rem 0 4rem',
        background: isDark 
          ? 'linear-gradient(135deg, #0A1929 0%, #182B3A 100%)' 
          : 'linear-gradient(135deg, #f8f9fa 0%, #e8e8e8 100%)',
        textAlign: 'center',
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div className="container">
          {/* Coming Soon Badge */}
          <div style={{
            display: 'inline-block',
            padding: '0.75rem 2rem',
            background: 'linear-gradient(135deg, #FFE8D0 0%, #FFF3E6 100%)',
            borderRadius: '50px',
            marginBottom: '2rem',
            animation: 'pulse 2s ease-in-out infinite'
          }}>
            <span style={{ 
              fontSize: '1.1rem', 
              fontWeight: 700,
              color: 'var(--accent)',
              letterSpacing: '1px'
            }}>
              🚀 COMING SOON
            </span>
          </div>

          {/* Main Heading */}
          <h1 style={{ 
            fontSize: 'clamp(2.5rem, 6vw, 4.5rem)', 
            marginBottom: '1.5rem',
            color: isDark ? '#E8EEF2' : '#0A1929',
            fontWeight: 800,
            lineHeight: 1.2
          }}>
            Current Affairs
            <br />
            <span style={{ 
              background: 'linear-gradient(135deg, var(--accent) 0%, #FFB570 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Monthly Test Series
            </span>
          </h1>

          {/* Description */}
          <p style={{ 
            fontSize: 'clamp(1.1rem, 2vw, 1.4rem)', 
            color: isDark ? '#B8C5D0' : '#4B5563',
            maxWidth: '800px', 
            margin: '0 auto 3rem',
            lineHeight: 1.8
          }}>
            Stay ahead with our comprehensive monthly test series covering national and international current affairs. 
            Designed specifically for UPSC, State PSC, and competitive exam aspirants.
          </p>

          {/* Large Icon */}
          <div style={{
            fontSize: '8rem',
            marginBottom: '2rem',
            opacity: 0.9
          }}>
            📅
          </div>

          {/* Feature Preview Cards */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '2rem',
            maxWidth: '1000px',
            margin: '3rem auto',
            textAlign: 'left'
          }}>
            {/* Feature 1 */}
            <div style={{
              padding: '2rem',
              background: isDark ? '#182B3A' : 'white',
              borderRadius: '16px',
              border: `2px solid ${isDark ? '#2C4456' : '#E5E7EB'}`,
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}>
              <div style={{ 
                fontSize: '3rem', 
                marginBottom: '1rem'
              }}>📰</div>
              <h3 style={{ 
                fontSize: '1.3rem',
                color: isDark ? '#E8EEF2' : 'var(--primary)',
                fontWeight: 700,
                marginBottom: '0.75rem'
              }}>
                Monthly Coverage
              </h3>
              <p style={{ 
                color: isDark ? '#B8C5D0' : '#6B7280',
                lineHeight: 1.6
              }}>
                Comprehensive tests covering all major events and developments from the past month
              </p>
            </div>

            {/* Feature 2 */}
            <div style={{
              padding: '2rem',
              background: isDark ? '#182B3A' : 'white',
              borderRadius: '16px',
              border: `2px solid ${isDark ? '#2C4456' : '#E5E7EB'}`,
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}>
              <div style={{ 
                fontSize: '3rem', 
                marginBottom: '1rem'
              }}>📊</div>
              <h3 style={{ 
                fontSize: '1.3rem',
                color: isDark ? '#E8EEF2' : 'var(--primary)',
                fontWeight: 700,
                marginBottom: '0.75rem'
              }}>
                Detailed Analysis
              </h3>
              <p style={{ 
                color: isDark ? '#B8C5D0' : '#6B7280',
                lineHeight: 1.6
              }}>
                In-depth performance analysis with personalized feedback and improvement suggestions
              </p>
            </div>

            {/* Feature 3 */}
            <div style={{
              padding: '2rem',
              background: isDark ? '#182B3A' : 'white',
              borderRadius: '16px',
              border: `2px solid ${isDark ? '#2C4456' : '#E5E7EB'}`,
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}>
              <div style={{ 
                fontSize: '3rem', 
                marginBottom: '1rem'
              }}>🎯</div>
              <h3 style={{ 
                fontSize: '1.3rem',
                color: isDark ? '#E8EEF2' : 'var(--primary)',
                fontWeight: 700,
                marginBottom: '0.75rem'
              }}>
                Exam-Oriented
              </h3>
              <p style={{ 
                color: isDark ? '#B8C5D0' : '#6B7280',
                lineHeight: 1.6
              }}>
                Questions designed following UPSC and State PSC exam patterns and difficulty levels
              </p>
            </div>
          </div>

          {/* Notify Me Section */}
          <div style={{
            maxWidth: '600px',
            margin: '4rem auto',
            padding: '3rem',
            background: isDark ? '#182B3A' : 'white',
            borderRadius: '20px',
            border: '3px solid var(--accent)',
            boxShadow: '0 20px 60px rgba(255, 140, 56, 0.2)'
          }}>
            <h3 style={{
              fontSize: '1.8rem',
              color: isDark ? '#E8EEF2' : 'var(--primary)',
              fontWeight: 700,
              marginBottom: '1rem'
            }}>
              Get Notified When We Launch
            </h3>
            <p style={{
              color: isDark ? '#B8C5D0' : '#6B7280',
              marginBottom: '2rem',
              lineHeight: 1.6
            }}>
              Be the first to know when our Current Affairs Monthly Test Series goes live!
            </p>
            
            <div style={{
              display: 'flex',
              gap: '1rem',
              flexWrap: 'wrap',
              justifyContent: 'center',
              marginBottom: message ? '1rem' : '0'
            }}>
              <input 
                type="email" 
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleNotifyMe()}
                disabled={loading}
                style={{
                  flex: '1',
                  minWidth: '250px',
                  padding: '1rem 1.5rem',
                  fontSize: '1rem',
                  borderRadius: '50px',
                  border: `2px solid ${isDark ? '#2C4456' : '#E5E7EB'}`,
                  background: isDark ? '#0A1929' : '#F9FAFB',
                  color: isDark ? '#E8EEF2' : '#0A1929',
                  outline: 'none',
                  opacity: loading ? 0.7 : 1
                }}
              />
              <button 
                onClick={handleNotifyMe}
                disabled={loading}
                style={{
                  padding: '1rem 2.5rem',
                  fontSize: '1rem',
                  fontWeight: 700,
                  color: 'white',
                  background: loading 
                    ? '#999' 
                    : 'linear-gradient(135deg, var(--accent) 0%, #FFB570 100%)',
                  border: 'none',
                  borderRadius: '50px',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  boxShadow: '0 10px 30px rgba(255, 140, 56, 0.3)',
                  transition: 'all 0.3s ease',
                  whiteSpace: 'nowrap'
                }}
                onMouseEnter={(e) => {
                  if (!loading) {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 15px 40px rgba(255, 140, 56, 0.4)';
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 140, 56, 0.3)';
                }}
              >
                {loading ? 'Saving...' : 'Notify Me'}
              </button>
            </div>
            
            {/* Success/Error Message */}
            {message && (
              <p style={{
                marginTop: '1rem',
                padding: '0.75rem',
                borderRadius: '10px',
                background: message.includes('try again') 
                  ? 'rgba(239, 68, 68, 0.1)' 
                  : 'rgba(34, 197, 94, 0.1)',
                color: message.includes('try again') 
                  ? '#ef4444' 
                  : '#22c55e',
                textAlign: 'center',
                fontSize: '0.95rem',
                fontWeight: 500
              }}>
                {message}
              </p>
            )}
          </div>

          {/* Back to Home Button */}
          <Link to="/" style={{ textDecoration: 'none' }}>
            <button style={{
              padding: '1rem 2.5rem',
              fontSize: '1.1rem',
              fontWeight: 600,
              color: isDark ? '#E8EEF2' : 'var(--primary)',
              background: 'transparent',
              border: `2px solid ${isDark ? '#E8EEF2' : 'var(--primary)'}`,
              borderRadius: '50px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              marginTop: '2rem'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = isDark ? '#E8EEF2' : 'var(--primary)';
              e.currentTarget.style.color = isDark ? '#0A1929' : 'white';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = isDark ? '#E8EEF2' : 'var(--primary)';
            }}>
              ← Back to Home
            </button>
          </Link>
        </div>
      </section>

      <Footer />

      {/* Pulse Animation */}
      <style jsx>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.05);
            opacity: 0.9;
          }
        }
      `}</style>
    </div>
  );
};

export default CurrentAffairsTestPage;
